module.exports = __webpack_public_path__ + "img/emailSuccess.1b6d1712.png";